import { Injectable } from '@angular/core'
import type { RowSwipeDirective } from './row-swipe.directive'

@Injectable({
  providedIn: 'root'
})
export class RowSwipeService {
  openRows: RowSwipeDirective[] = []
  inProgress = false

  constructor() {}

  /**
   * Register a new open row, so that only 1 row at the time is open
   * @param {RowSwipeDirective} row
   */
  registerRow(row: RowSwipeDirective): void {
    // Close all registered rows
    if (this.openRows.length > 0) {
      this.openRows.forEach(rw => {
        if (row !== rw) {
          rw.closeRow()
        }
      })
    }

    // Empty array
    this.openRows = []

    // Add row to array
    this.openRows.push(row)
  }

  /**
   * Removes row from the current open rows
   * @param {RowSwipeDirective} row
   */
  unregisterRow(row: RowSwipeDirective): void {
    this.openRows = this.openRows.filter(rw => rw !== row)
  }

  /**
   * Closes all open rows, except the one given.
   * @param {RowSwipeDirective} [except] Row that stays open, for example the row a new swipe starts on.
   */
  closeRows(except?: RowSwipeDirective): void {
    const rows = this.openRows.filter(rw => rw !== except)

    this.openRows = except && this.openRows.includes(except) ? [except] : []
    rows.forEach(rw => rw.closeRow())
  }

  /**
   * Closes open rows inside one list surface without touching rows in other surfaces.
   * @param {Node} root Surface whose rows may be closed.
   */
  closeRowsWithin(root: Node): void {
    this.openRows.filter(row => row.isWithin(root)).forEach(row => row.closeRow())
  }
}
